import {NextPageContext} from 'next';
import Head from 'next/head';

import {HeadSEO} from '@udemy/head-seo';
import {RENDER_MODES} from '@udemy/nextjs-core';
import {ErrorPage} from '@udemy/react-structure-components';

import {getLayout} from 'src/components/layout';
import {getCompactTranslations} from 'src/lib-server/locale.server';
import {META_DEFAULT_BASE_URL} from 'src/lib/constants';
import {AppContextData} from 'src/types/page-props';

import {getStaticAppContext} from './api/context.api';

export async function getStaticProps(context: NextPageContext) {
    const locale = context.locale as string;
    const translations = await getCompactTranslations(locale);

    // Resolve appContext
    const [staticData] = await Promise.all([getStaticAppContext({locale})]);

    const appContext: AppContextData = staticData;

    return {
        props: {
            appContext,
            locale,
            pageKey: '404',
            renderMode: RENDER_MODES.ISR, // supports render functions in _document.tsx and _app.tsx.
            translations,
        },
    };
}

export default function NotFoundPage() {
    return (
        <>
            <HeadSEO
                canonicalUrl={META_DEFAULT_BASE_URL}
                assetPath={process.env.ASSET_PREFIX}
                headWrapper={Head}
                errorPage={true}
            />
            <ErrorPage />
        </>
    );
}

NotFoundPage.getLayout = getLayout;
